import type { Icon } from "@phosphor-icons/react";

export function ContextEmpty({ icon: EmptyIcon, description }: { icon: Icon; description: string }) {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-border bg-card/60 px-12 py-14 text-center text-balance">
      <div className="flex max-w-sm flex-col items-center gap-2">
        <span className="mb-2 flex size-10 items-center justify-center rounded-lg bg-muted text-foreground">
          <EmptyIcon weight="duotone" className="size-6" />
        </span>
        <p className="text-sm/relaxed text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
